import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * BreadcrumbSchema Component
 * Renders breadcrumb structured data for improved navigation in SERPs
 */
export default function BreadcrumbSchema({ breadcrumbs = [] }) {
  if (!breadcrumbs || breadcrumbs.length === 0) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((crumb, idx) => ({
      "@type": "ListItem",
      "position": idx + 1,
      "name": crumb.name,
      "item": crumb.url
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}